import React, { useEffect } from "react";
import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { useForm } from "react-hook-form";
import WBTextField from "components/input/WBTextField";
import { getCookie } from "services/utils/CookieHandler";
import { urlChatPage, urlSupportPage } from "services/utils/globalVariables";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddTicketContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        height: 100%;
        padding: 0 16px;
        // justify-content: space-between;
    `
)
const SupportTicketButton = styled(Button)(
    ({theme}) => `
        width: 100%;
        color: ${theme.palette.secondary.main} !important;
        margin-top: ${theme.spacing(3)};
        font-weight: bolder;
    `
)

const BackButtonTopStyle = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        padding: 16px 19px;
        background: #16423C;
        border-radius: 0 0 8px 8px;
        z-index: 999;
    `
)

export default function AddTicketPage({ connection }) {

    const { handleSubmit, control, reset, formState: {errors} } = useForm();
    const navigate = useNavigate()

    const loginInfo = getCookie("loginData")

    //Adding a new ticket with SignalR
    const handleSubmitData = (data) => {
        if(connection?._connectionState === "Connected") {
            connection.send("AddTicket", data.Subject, data.Message, loginInfo.accessToken)
            connection.on("ResultAddTicket", res => {
                toast.success("تیکت شما با موفقیت ثبت شد")
                setTimeout(() => navigate(`${urlChatPage}/${res.data}`), 1000)
            })
        }
    }


    return (
        <Stack sx={{direction: "ltr !important", height: "calc(100vh - 160px)"}}>
            <AddTicketContainer spacing={2} >
                <BackButtonTopStyle direction="row" justifyContent="flex-end">
                    <ArrowBackIosNewIcon sx={{color: "white", fontSize: "20px"}} onClick={() => navigate(urlSupportPage)} />
                </BackButtonTopStyle>
                <Stack
                    component="form"
                    onSubmit={handleSubmit(handleSubmitData)}
                    justifyContent="space-between"
                    spacing={1}
                    sx={{height: "100%"}}
                >
                    <Stack spacing={2}>
                        <WBTextField
                            control={control}
                            name="Subject"
                            label="عنوان"
                            isRequired={true}
                            multiline
                        />
                        <WBTextField
                            control={control}
                            name="Message"
                            label="متن پیام"
                            isRequired={true}
                            multiline
                            minRows={5}
                        />
                    </Stack>
                    <SupportTicketButton size="large" color="primary" variant="contained" type="submit" >
                        ثبت تیکت
                    </SupportTicketButton>
                </Stack>
            </AddTicketContainer>
        </Stack>
    )
}